import { CondicionPagoRef, separarCondiciones } from '../lib/condicionesPago';

const etiqueta = (c: CondicionPagoRef) => (c.tipo ? `${c.nombre} (${c.tipo})` : c.nombre);

/**
 * Opciones de un <select> de condición de pago (por nombre): primero las que ofrece el proveedor y el resto del
 * catálogo en "Otras condiciones". Si el proveedor no ofrece ninguna, todo el catálogo sin grupos.
 */
export function OpcionesCondicionPago({ catalogo, ofrecidas }: { catalogo: CondicionPagoRef[]; ofrecidas?: CondicionPagoRef[] }) {
  const grupos = separarCondiciones(catalogo, ofrecidas);
  const opciones = (lista: CondicionPagoRef[]) => lista.map(c => <option key={c.id} value={c.nombre}>{etiqueta(c)}</option>);
  if (grupos.ofrecidas.length === 0) return <>{opciones(grupos.otras)}</>;
  return (
    <>
      <optgroup label="Del proveedor">{opciones(grupos.ofrecidas)}</optgroup>
      {grupos.otras.length > 0 && <optgroup label="Otras condiciones">{opciones(grupos.otras)}</optgroup>}
    </>
  );
}

/**
 * Condiciones de pago que ofrece el proveedor (casillas). La predeterminada se ofrece siempre: aparece tildada y no
 * se puede destildar mientras sea la predeterminada.
 */
export function CondicionesOfrecidas({ catalogo, predeterminadaId, seleccionadas, onChange }: {
  catalogo: CondicionPagoRef[];
  predeterminadaId: number | string | null | undefined;
  seleccionadas: number[];
  onChange: (ids: number[]) => void;
}) {
  const predeterminada = predeterminadaId === '' || predeterminadaId == null ? null : Number(predeterminadaId);
  const cambiar = (id: number, tildada: boolean) =>
    onChange(tildada ? [...seleccionadas.filter(s => s !== id), id] : seleccionadas.filter(s => s !== id));
  if (catalogo.length === 0) return <p className="text-xs text-slate-500">No hay condiciones de pago activas.</p>;
  return (
    <div className="border rounded-lg max-h-40 overflow-y-auto divide-y">
      {catalogo.map(c => {
        const esPredeterminada = c.id === predeterminada;
        return (
          <label key={c.id} className="flex items-center gap-2 px-3 py-1.5 text-sm">
            <input type="checkbox" checked={esPredeterminada || seleccionadas.includes(c.id)} disabled={esPredeterminada}
              onChange={e => cambiar(c.id, e.target.checked)} />
            <span>{etiqueta(c)}</span>
            {esPredeterminada && <span className="text-xs text-slate-500">(predeterminada)</span>}
          </label>
        );
      })}
    </div>
  );
}
